import {Dispatch, FC, SetStateAction, useState} from 'react';
import {useTranslation} from 'react-i18next';

import ComboboxAsync from '@/components/form/combobox/combobox-async';
import FieldWrapper from '@/components/form/field-wrapper';
import {AdvisorCodes} from './advisor-code-step';
import {InvestorComboboxValue} from './search-investors-as-combobox-values';
import {useSearchInvestorsMutation} from './use-search-investors-mutation';

type Props = {
  advisorCodes: AdvisorCodes;
  selectedContractHolder: InvestorComboboxValue | null;
  onSelectContractHolder: Dispatch<SetStateAction<InvestorComboboxValue | null>>;
};

export const SearchContractHolderStep: FC<Props> = ({advisorCodes, selectedContractHolder, onSelectContractHolder}) => {
  const {t} = useTranslation();

  const [searchResults, setSearchResults] = useState<InvestorComboboxValue[]>([]);
  const searchInvestorsMutation = useSearchInvestorsMutation(advisorCodes, {
    analytics_search_location: 'nouvelle-demande',
  });

  return (
    <>
      <h3 className="font-bold" data-testid="new-document-investor-select-title">
        {t('components.new-document-creation.dialog.content.step-search-contract-holder.section-title')}
      </h3>

      <FieldWrapper
        identifier="new-document-investor-select-wrapper"
        label={t('components.new-document-creation.dialog.content.step-search-contract-holder.combobox-label')}
        showAssistiveText={false}
      >
        <ComboboxAsync<InvestorComboboxValue>
          data-testid="new-document-investor-select"
          placeholder={t(
            'components.new-document-creation.dialog.content.step-search-contract-holder.combobox-placeholder',
          )}
          searchResults={searchResults}
          setSearchResults={setSearchResults}
          fetchSearchResultsMutation={searchInvestorsMutation}
          selectedValue={selectedContractHolder}
          onChange={onSelectContractHolder}
        />
      </FieldWrapper>
    </>
  );
};
